// 個人資料 → 優惠碼分頁：輸入優惠碼延長體驗期（每組碼每人限用一次）。
// 兌換：POST /api/users/redeem-promo；狀態：GET /api/users/promo/context。
import { useEffect, useState, useContext } from "react";
import { Card, CircularProgress, Chip } from "@mui/material";
import { toast } from "react-toastify";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import axiosInstance from "api/axiosInstance";
import { LanguageContext } from "../../../../context/LanguageContext";
import { COLORS } from "theme/tokens";

const fmtDate = (v) => (v ? new Date(v).toLocaleDateString() : "-");

export default function PromoCodeRedeemTab() {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);
  const [loading, setLoading] = useState(true);
  const [ctx, setCtx] = useState(null);
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    loadLanguageFile("PromoCodeRedeemTab", "profile/PromoCodeRedeemTab/PromoCodeRedeemTab_lang");
  }, [language, loadLanguageFile]);
  const L = (componentLanguageData.PromoCodeRedeemTab || { Main: {} }).Main || {};

  const fetchCtx = () => {
    setLoading(true);
    axiosInstance
      .get("/users/promo/context")
      .then((res) => setCtx(res.data || null))
      .catch(() => setCtx(null))
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    fetchCtx();
  }, []);

  const handleRedeem = async () => {
    const c = code.trim();
    if (!c) {
      toast.error(L.ErrEmpty || "請輸入優惠碼");
      return;
    }
    setBusy(true);
    try {
      const res = await axiosInstance.post("/users/redeem-promo", { code: c });
      const d = res.data || {};
      const parts = [];
      if (d.coinAmount > 0) parts.push((L.RewardCoin || "{coins} MAS Coin").replace("{coins}", d.coinAmount));
      if (d.trialExtendDays > 0)
        parts.push(
          (L.RewardTrial || "延長體驗 {days} 天（至 {date}）")
            .replace("{days}", d.trialExtendDays)
            .replace("{date}", fmtDate(d.trialEndsAt))
        );
      toast.success((L.SuccessPrefix || "兌換成功！獲得：") + parts.join(L.Sep || "、"));
      setCode("");
      fetchCtx();
    } catch (e) {
      const code = e?.response?.data?.code;
      const localized = code && L.Errors && L.Errors[code];
      toast.error(localized || e?.response?.data?.message || L.ErrRedeem || "兌換失敗，請確認優惠碼");
    } finally {
      setBusy(false);
    }
  };

  const active = ctx && ctx.isTrialActive && ctx.remainingDays > 0;

  return (
    <Card sx={{ p: { xs: 2.5, md: 3 }, borderRadius: 3, boxShadow: 0, border: `1px solid ${COLORS.grayLighter || "#eee"}`, maxWidth: 560 }}>
      <MDBox display="flex" alignItems="center" gap={1} mb={1}>
        <MDTypography variant="h6" fontWeight="bold">
          {L.Title || "優惠碼"}
        </MDTypography>
      </MDBox>

      <MDTypography variant="body2" color="text" mb={2.5}>
        {L.Desc || "輸入優惠碼可延長您的體驗期。每組優惠碼每人限用一次。"}
      </MDTypography>

      {loading ? (
        <CircularProgress size={22} color="info" />
      ) : (
        <>
          <MDBox display="flex" alignItems="center" gap={1.5} mb={2.5} flexWrap="wrap">
            <MDTypography variant="button" fontWeight="medium" color="text">
              {L.StatusLabel || "目前體驗："}
            </MDTypography>
            {active ? (
              <Chip
                label={(L.StatusActive || "剩 {days} 天（至 {date}）")
                  .replace("{days}", ctx.remainingDays)
                  .replace("{date}", fmtDate(ctx.trialEndsAt))}
                color="success"
                size="small"
              />
            ) : (
              <Chip label={L.StatusInactive || "無進行中的體驗"} size="small" />
            )}
          </MDBox>

          <MDBox display="flex" gap={1.5} flexWrap="wrap" alignItems="center">
            <MDInput
              value={code}
              onChange={(e) => setCode(e.target.value.toUpperCase())}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleRedeem();
              }}
              placeholder={L.Placeholder || "輸入優惠碼"}
              size="small"
              disabled={busy}
              sx={{ minWidth: 220 }}
            />
            <MDButton variant="gradient" color="info" disabled={busy} onClick={handleRedeem} sx={{ textTransform: "none" }}>
              {busy ? <CircularProgress size={18} color="inherit" /> : L.RedeemBtn || "兌換"}
            </MDButton>
          </MDBox>
        </>
      )}
    </Card>
  );
}
